import ConversationLifecycle, { ManagedConversationProps } from './ConversationLifecycle';
import {
  useEffect,
  useMemo,
} from 'react';
import {
  useLocation,
} from 'react-router-dom';

import {
  useChatSession,
} from '../hooks/useChatSession';
import {
  useRetziaUser,
} from '../hooks/useRetziaUser';
import {
  navigateWithSession,
  replaceWithSession,
} from '../services/sessionNavigation';
import RetziaActivityWorkspace from './retzia/RetziaActivityWorkspace';
import {
  CONVERSATION_FIRST_MESSAGES,
  CONVERSATION_TOPICS,
} from './retzia/workspaceConfig';

function ChatSession({initialConversation, requestNew, onPersistenceConflict}: ManagedConversationProps) {
  const location = useLocation();

  const language: string =
    location.state?.language ??
    new URLSearchParams(
      location.search
    ).get('language') ??
    '';

  const {
    currentUser,
    checking,
  } = useRetziaUser();

  const firstMessage =
    CONVERSATION_FIRST_MESSAGES[language] ??
    CONVERSATION_FIRST_MESSAGES.french;

  const topics = useMemo(
    () => [
      ...(CONVERSATION_TOPICS[language] ??
        CONVERSATION_TOPICS.english),
    ].sort(() => Math.random() - 0.5),
    [language]
  );

  const session = useChatSession({
    initialConversation,
    onPersistenceConflict,
    language,
    mode: 'conversation',
    firstMessage,
    messagesLimit: Infinity,
    feedbackThreshold: 5,
    alwaysTTS: true,
  });

  useEffect(() => {
    if (!checking && !currentUser) {
      replaceWithSession(
        `/login?language=${encodeURIComponent(
          language
        )}&returnTo=chat`
      );
    }
  }, [
    checking,
    currentUser,
    language,
  ]);

  if (checking || !currentUser) {
    return null;
  }

  return (
    <RetziaActivityWorkspace
      language={language}
      session={session}
      newConversationLabel="Nuevo chat"
      onNewConversation={() => void requestNew(session.prepareForNewConversation)}
      newConversationDisabled={!session.isConversationReady || session.isWaitingForBot || session.isMicActivated}
      persistenceError={session.persistenceError}
      reportMode="conversation"
      hideFirstMessage
      inputPlaceholder="Escribe aquí…"
      topics={topics}
      topicsLayout="rail"
      onClose={() =>
        navigateWithSession('/home')
      }
    />
  );
}

function Chat() {
  const location = useLocation();
  const language: string = location.state?.language ?? new URLSearchParams(location.search).get('language') ?? '';
  return <ConversationLifecycle key={language} language={language} mode="conversation">
    {props => <ChatSession {...props} />}
  </ConversationLifecycle>;
}
export default Chat;
